<template>
    <ResultsNetworkBanner bannerType="info" :header="header">
        <span>
            <ApplicationTier :result="result" :tierLabel="currentPlanTierLabel" v-if="currentPlanIsTiered && result.tier" />
        </span>
    </ResultsNetworkBanner>
</template>

<script setup>
    const props = defineProps({
        result: Object,
        rank: Number
    })
    const { plan, currentPlanName, currentPlanTierLabel, currentPlanIsTiered } = useFCPModel()
    const header = computed(() => plan.value.networkId != '1052' ? `In ${currentPlanName.value} network.` : 'No network selected')

</script>